import React, { Children } from 'react';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPolicy() {
  return <div className="min-h-screen bg-white" data-id="element-157">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800" data-id="element-158">
        <div className="container mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-159">
          <a href="#" className="flex items-center space-x-2 text-white hover:text-cyan-400 transition-colors" data-id="element-160">
            <ArrowLeft className="w-5 h-5" data-id="element-161" />
            <span className="font-medium" data-id="element-162">Back to Home</span>
          </a>
        </div>
      </nav>

      <main className="pt-24 pb-16" data-id="element-163">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-164">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-165">
            Privacy Policy
          </h1>
          <p className="text-slate-600 mb-12" data-id="element-166">Last updated: January 1, 2026</p>

          <div className="prose prose-slate max-w-none" data-id="element-167">
            <section className="mb-8" data-id="element-168">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-169">
                1. Information We Collect
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-170">
                We collect information that you provide directly to us,
                including when you create an account, use our services, or
                communicate with us. This may include your name, email address,
                and other contact information.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-171">
                We also automatically collect certain information about your
                device and how you interact with our services, including IP
                address, browser type, operating system, and usage data.
              </p>
            </section>

            <section className="mb-8" data-id="element-172">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-173">
                2. How We Use Your Information
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-174">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-175">
                <li data-id="element-176">Provide, maintain, and improve our services</li>
                <li data-id="element-177">Process transactions and send related information</li>
                <li data-id="element-178">Send technical notices, updates, and support messages</li>
                <li data-id="element-179">Respond to your comments and questions</li>
                <li data-id="element-180">Monitor and analyze trends, usage, and activities</li>
                <li data-id="element-181">
                  Detect, prevent, and address technical issues and security
                  threats
                </li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-182">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-183">
                3. Information Sharing
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-184">
                We do not share your personal information with third parties
                except in the following circumstances:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-185">
                <li data-id="element-186">With your consent or at your direction</li>
                <li data-id="element-187">
                  With service providers who perform services on our behalf
                </li>
                <li data-id="element-188">
                  To comply with legal obligations or respond to legal requests
                </li>
                <li data-id="element-189">
                  To protect the rights, property, and safety of Remote Systems,
                  our users, or others
                </li>
                <li data-id="element-190">
                  In connection with a merger, acquisition, or sale of assets
                </li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-191">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-192">
                4. Data Security
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-193">
                We implement appropriate technical and organizational measures
                to protect your personal information against unauthorized
                access, alteration, disclosure, or destruction. However, no
                method of transmission over the internet or electronic storage
                is 100% secure.
              </p>
            </section>

            <section className="mb-8" data-id="element-194">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-195">
                5. Your Rights
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-196">
                Depending on your location, you may have certain rights
                regarding your personal information, including:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-197">
                <li data-id="element-198">Access to your personal information</li>
                <li data-id="element-199">Correction of inaccurate information</li>
                <li data-id="element-200">Deletion of your information</li>
                <li data-id="element-201">Objection to or restriction of processing</li>
                <li data-id="element-202">Data portability</li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-203">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-204">
                6. Cookies and Tracking
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-205">
                We use cookies and similar tracking technologies to collect
                information about your browsing activities. You can control
                cookies through your browser settings, though disabling cookies
                may affect your ability to use certain features of our services.
              </p>
            </section>

            <section className="mb-8" data-id="element-206">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-207">
                7. Children's Privacy
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-208">
                Our services are not directed to children under 13 years of age.
                We do not knowingly collect personal information from children
                under 13. If you become aware that a child has provided us with
                personal information, please contact us.
              </p>
            </section>

            <section className="mb-8" data-id="element-209">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-210">
                8. Changes to This Policy
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-211">
                We may update this Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page and updating the "Last updated" date.
              </p>
            </section>

            <section className="mb-8" data-id="element-212">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-213">
                9. Contact Us
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-214">
                If you have any questions about this Privacy Policy, please
                contact us at info@remotesystems.xyz
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>;
}